import React from "react";

export default function FieldSettingsPanel({ field, onChangeField, onDeleteField }) {
  return (
    <aside className="rounded-xl border bg-white p-4 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-900">Field Settings</h3>

      {!field && <p className="mt-2 text-sm text-gray-500">Selecteer eerst een veld in het canvas.</p>}

      {field && (
        <div className="mt-3 space-y-3">
          <label className="block">
            <span className="mb-1 block text-xs font-medium text-gray-600">Label</span>
            <input
              value={field.label || ""}
              onChange={(event) => onChangeField("label", event.target.value)}
              className="w-full rounded border border-gray-300 px-3 py-2 text-sm"
            />
          </label>

          <label className="block">
            <span className="mb-1 block text-xs font-medium text-gray-600">Placeholder</span>
            <input
              value={field.placeholder || ""}
              onChange={(event) => onChangeField("placeholder", event.target.value)}
              className="w-full rounded border border-gray-300 px-3 py-2 text-sm"
            />
          </label>

          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={Boolean(field.required)}
              onChange={(event) => onChangeField("required", event.target.checked)}
            />
            Verplicht
          </label>

          {field.type === "photo" && (
            <label className="flex items-center gap-2 text-sm">
              <input
                type="checkbox"
                checked={Boolean(field.multiple)}
                onChange={(event) => onChangeField("multiple", event.target.checked)}
              />
              Meerdere foto's toestaan
            </label>
          )}

          {field.type === "select" && (
            <SelectOptionsEditor
              options={Array.isArray(field.options) ? field.options : []}
              onChange={(options) => onChangeField("options", options)}
            />
          )}

          <button
            type="button"
            onClick={onDeleteField}
            className="rounded border border-red-200 px-3 py-2 text-sm text-red-700 hover:bg-red-50"
          >
            Veld verwijderen
          </button>
        </div>
      )}
    </aside>
  );
}

function SelectOptionsEditor({ options, onChange }) {
  function updateOption(index, value) {
    onChange(options.map((item, idx) => (idx === index ? value : item)));
  }

  function addOption() {
    onChange([...(options || []), `Optie ${(options || []).length + 1}`]);
  }

  function removeOption(index) {
    onChange(options.filter((_, idx) => idx !== index));
  }

  return (
    <div className="rounded border border-gray-200 p-3">
      <p className="mb-2 text-xs font-medium text-gray-600">Options</p>
      <div className="space-y-2">
        {(options || []).map((option, index) => (
          <div key={`${index}-${option}`} className="flex items-center gap-2">
            <input
              value={option}
              onChange={(event) => updateOption(index, event.target.value)}
              className="flex-1 rounded border border-gray-300 px-2 py-1 text-sm"
            />
            <button
              type="button"
              onClick={() => removeOption(index)}
              className="rounded border border-red-200 px-2 py-1 text-xs text-red-700 hover:bg-red-50"
            >
              X
            </button>
          </div>
        ))}
      </div>

      <button
        type="button"
        onClick={addOption}
        className="mt-2 rounded border border-gray-300 px-2 py-1 text-xs text-gray-700 hover:bg-gray-50"
      >
        Optie toevoegen
      </button>
    </div>
  );
}
